import { Button, Typography, message } from "antd";
import NestedFormRender from "./NestedFormRender";
import { useEffect } from "react";
import utils from "utils";
import { filterEmptyValues, isEmpty } from "./AIFormCombinedView";

function AIFormEdit({ formData, setEditRecord, steAIFormData,is_review_screen }) {
  // const initial_data = formData.displayValue
  //   ? formData.displayValue
  //   : formData?.value;
  const initial_data = formData?.value;  
  const handleCancel = () => {
    setEditRecord(null);
  };
  const onSave = (values) => {
    let data = values[formData?.label];
    if(isEmpty(filterEmptyValues(data))){
      message.warning("Please Enter Values");
      return;
    }
    if (typeof data == "object" && !Array.isArray(data)) {
      const valuesDefaultKeys = addMissingKeys(initial_data, data); //appending keys
      // data = getFinalValue(initial_data, valuesDefaultKeys); //formlist initial
      data = valuesDefaultKeys;
    }
    let displayData;
    if (formData?.displayValue) {
      if (Array.isArray(data)) {
        displayData = data.join(", ");
      } else if (typeof data !== "object") {
        displayData = data;
      }
    }
    steAIFormData((prevArray) =>
      prevArray.map((item) => {
        if (item.id === formData.id) {
          return {
            ...item,
            value: data,
            ...(item.displayValue && { displayValue: displayData }),
          };
        }
        return item;
      })
    );
    setEditRecord(null);
  };
  return (
    <div style={{ padding: "10px" }}>
      {!is_review_screen && (
        <Typography>{utils.capitalizeAndReplace(formData?.title)}</Typography>
      )}
      <NestedFormRender
        initialValues={{
          [formData?.label]: initial_data,
        }}
        fieldOptions={formData?.field_option || {}}
        fieldValue={formData?.field_type || {}}
        onSave={onSave}
        handleCancel={handleCancel}
        formClass={formData?.title}
      />
    </div>
  );
}
function getFinalValue(initialValue, finalValue) {
  const defaultValues = (obj) => {
    if (Array.isArray(obj)) {
      return obj.length > 0 ? obj.map((item) => defaultValues(item)) : [{}];
    } else if (typeof obj === "object" && obj !== null) {
      return Object.keys(obj).reduce((acc, key) => {
        const value = obj[key];
        if (typeof value === "string") {
          acc[key] = "";
        } else if (typeof value === "number") {
          acc[key] = 0;
        } else if (Array.isArray(value)) {
          acc[key] = defaultValues(value);
        } else if (typeof value === "object") {
          acc[key] = defaultValues(value);
        }
        return acc;
      }, {});
    }
    return obj;
  };

  const buildFinalValue = (initial, final) => {
    return Object.keys(initial).reduce((acc, key) => {
      if (Array.isArray(initial[key])) {
        acc[key] = final[key]?.length
          ? final[key]
          : defaultValues(initial[key]);
      } else if (typeof initial[key] === "object" && initial[key] !== null) {
        acc[key] = buildFinalValue(initial[key], final[key] || {});
      } else {
        acc[key] =
          final[key] !== undefined ? final[key] : defaultValues(initial[key]);
      }
      return acc;
    }, {});
  };

  return buildFinalValue(initialValue, finalValue);
}
function mergeObjects(obj1, obj2, defaultValues = {}) {
  if (
    typeof obj1 !== "object" ||
    typeof obj2 !== "object" ||
    obj1 === null ||
    obj2 === null
  )
    return obj1;

  if (Array.isArray(obj1) && Array.isArray(obj2)) {
    return obj1.map((item, index) =>
      mergeObjects(item, obj2[index] || {}, defaultValues)
    );
  }

  const allKeys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

  return Array.from(allKeys).reduce((acc, key) => {
    if (Object.hasOwn(obj2, key)) {
      acc[key] = mergeObjects(obj1[key], obj2[key], defaultValues);
    } else if (typeof obj1[key] === "string") {
      acc[key] = defaultValues.string || "";
    } else if (typeof obj1[key] === "number") {
      acc[key] = defaultValues.number || 0;
    } else if (Array.isArray(obj1[key])) {
      acc[key] = defaultValues.array || [];
    } else {
      acc[key] = defaultValues.default || null;
    }
    return acc;
  }, {});
}
function addMissingKeys(obj1, obj2) {
  Object.keys(obj1).forEach((key) => {
    if (
      obj2[key] === undefined ||
      (Array.isArray(obj2[key]) && obj2[key].length == 0)
    ) {
      if (Array.isArray(obj1[key])) {
        if (obj1[key].length > 0) {
          if (typeof obj1[key][0] === "object") {
            obj2[key] = [{}];
            addMissingKeys(obj1[key][0], obj2[key][0]);
          } else {
            // obj2[key] = obj1[key];
            obj2[key] = [];
          }
        } else {
          obj2[key] = [];
        }
      } else if (typeof obj1[key] === "object" && obj1[key] !== null) {
        obj2[key] = {};
        addMissingKeys(obj1[key], obj2[key]);
      } else {
        let valueType = typeof obj1[key];
        // obj2[key] = obj1[key] === null? "" : obj1[key];
        switch (valueType) {
          case "string":
            obj2[key] = "";
            break;
          case "number":
            obj2[key] = 0;
            break;
        }
      }
    }
  });
  return obj2;
}

function updateObject(obj1, obj2) {
  Object.keys(obj1).forEach((key) => {
    if (typeof obj1[key] === "object" && obj1[key] !== null) {
      updateObject(obj1[key], obj2);
    } else if (Array.isArray(obj1[key])) {
      obj1[key].forEach((item) => {
        updateObject(item, obj2);
      });
    } else {
      if (key in obj2) {
        // perform operation on obj1[key] using obj2[key]
        obj1[key] = doSomethingWith(obj1[key], obj2[key]);
      }
    }
  });
}

function doSomethingWith(value1, value2) {
  // implement your logic here
  return value1 + "" + value2;
}

// updateObject(object1, object2);

export default AIFormEdit;
